import styled from "styled-components"

export const CordStyles = styled.img`
  position: relative;
  top: 38px;
  height: 46px;
`

export default CordStyles
